import { render, staticRenderFns } from "./DocumentContainer.vue?vue&type=template&id=1de3ea9f&scoped=true"
import script from "./DocumentContainer.vue?vue&type=script&lang=js"
export * from "./DocumentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3ea9f",
  null
  
)

export default component.exports